import React from "react";

import SendIcon from "./assets/send-icon";

export default function ChatbotInput({ controller }) {
  function onInputChange(element) {
    // https://stackoverflow.com/questions/2803880/is-there-a-way-to-get-a-textarea-to-stretch-to-fit-its-content-without-using-php#:~:text=%3C-,textarea,-name%3D%22text
    element.target.style.height = "";
    element.target.style.height = element.target.scrollHeight + "px";
  }

  const buttonClass = "send-button" + (controller.isLoading ? " disabled" : " active");

  return (
    <div className="chatbot-input">
      <div className="input-wrapper">
        <textarea ref={controller.chatInputRef} placeholder="Ask AI Chatbot here" onInput={onInputChange} disabled={controller.isLoading}></textarea>
      </div>
      <div className={buttonClass} onClick={controller.onSend}>
        <SendIcon />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/chatbot/chatbot_input.js